
import React, { Component, createRef  } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { get, post, del, getFreshToken } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import '../adminDash.css';
import axios from "axios"; // Import axios for API requests
import no_img from '../../assets/No_Image_Available (4).jpg';
import globalVariables from "../../custom_libraries/globalVariables";
import withNavigate from "../../Global_files/WithNavigate";
import NoCameraConnected from "../../assets/cam-offline.jpg"
import MinusIcon from "../../assets/icons8-minus-32.png"
import PlusIcon from "../../assets/icons8-plus-32.png"
import ExclaimIcon from "../../assets/icons8-exclamation-32.png"
import Navigationbar from '../Navigationbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
//import mui components to inhance the look
import { Button, Snackbar, Alert } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from "react-router-dom";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Paper, IconButton, Typography, Collapse, Box,Tabs, Tab } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import LinkIcon from '../../assets/ip-globe-icon.png';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import DialogBox from '../DialogBox';
import Scheduler from './Scheduler';
import EditIcon from '../../assets/icons8-edit-new-64.png';
import SameImageStatus from '../../assets/icons8-check-active.png';
import DiffImageStatus from '../../assets/icons8-cross-48.png';
import QuestionMarkImage from '../../assets/icons8-question-mark-64.png';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import SyncIcon from '../../assets/icons8-synchronize-96.png';
// import SyncIcon from '../../assets/icons8-synchronize-48.png';
import SyncIcon1 from '../../assets/icons8-synchronize-96-1.png';
import { fabric } from 'fabric';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CameraCanvas from './CameraCanvas';
import { DateTime } from "luxon";

class AboutDevice extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.canvas = null;

    this.state = {
      selectedSite: null,
      selectedSiteInfo: null, 
      cameras: [],
      loading: true,
      devices: [],
      searchInput: "",
      currentPage: 1,
      rowsPerPage: 5,
      device_details: [],

      expandedRow: null, // Track which row is expanded
      nestedExpandedRow: null,
      ref_img_created_time: null,
      ref_img_next_inspection: "",
      latest_img_taken_at: null,
      capturedImageBlob: null,
      capturedLatestImageBlob: null,
      currentTime_of_device: null,
      selectedCamera: null,
      isPopupVisible: false,
      activeSection: 'reference',	// State to track the active collapsible section

      deviceId: '',
      snackbar_msg: '',
      open_snackbar: false,

      confirmDialog: {
        isOpen: false,
        title: '',
        subtitle: '',
      },

      open_MuteUnmute_Dialogue: false,
      mute: false,
      selectedCameraId: null,
      muteResponseMessage: '',
      error2: false,
      success2: false,
      success: false,

      image1: '',
      ref_img_id: null,
      image2: '',
      imageURL: "",

      site_list: [],
      filteredDevices: [], // Devices to display based on filter

      refreshSystemOverviewstatuscard: false,

      //add site----
      toggleAddSite: false,
      sitename: '',
      address: '',
      city:'',
      street:'',
      zip:'',
      country:'',
      state:'',
      organisationName: '',
      warning_site: false,
      success_site: false,
      error_site: false,
      open_progress_bar: false,
      user_name:'',
      user_type:'',
      client_list:[],
      selected_Customers:[],
      Selected_Device_Id:null,
      SiteName:'',
      DeviceName:'',

      activeTab: 0, // Default to the first tab (General Info)
      templateEditToggle : false,
      template_list: [],
      template_name : '',
      
      toggleIgnoreZone:false,
      showDiskDetails: false
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    const siteName = localStorage.getItem(globalVariables.SITE_NAME);
    const deviceName= localStorage.getItem(globalVariables.DEVICE_NAME);
    const Selected_Device_Id = localStorage.getItem(globalVariables.DEVICE_ID);
    this.setState({ Selected_Device_Id }, () => {
        this.LoadSelectedDeviceInfo(); // Ensure this runs after state is updated
    });
    const user_type = localStorage.getItem(globalVariables.USER_TYPE);
    this.setState ({
        SiteName : siteName,
        DeviceName : deviceName,
        user_type : user_type
    })
    this.handleFetchTemplate()

    // Add event listener for keydown
    document.addEventListener("keydown", this.handleKeyDown);


    //-------- Initialize Fabric.js canvas only once-----
    this.canvas = new fabric.Canvas(this.canvasRef.current);
    // this.canvas.setWidth(800);
    // this.canvas.setHeight(600);

    // Bind Fabric.js events
    this.canvas.on("mouse:down", this.handleMouseDown);
    this.canvas.on("mouse:move", this.handleMouseMove);
    this.canvas.on("mouse:up", this.handleMouseUp);
  }

  validateSignedIn = async () => {
    try {
      let is_fresh_token = await getFreshToken();
      console.log("Fresh Token:", is_fresh_token);
  
      if (!is_fresh_token) {
        console.log("Navigating to login...");
        this.props.navigate("/");
        return;
      }
    } catch (error) {
      console.error("Error in validateSignedIn:", error);
    }
  }

//   componentDidUpdate(prevProps, prevState) {
//     if (
//         this.state.success2 !== prevState.success2
//     ) {
//         if (
//             this.state.success2
//         ) {
//             setTimeout(() => {
//                 this.setState({
//                     success2: false,
//                 });
//             }, 3000); // 1 second
//         }
//     }
// }

    componentWillUnmount() {
      // Remove event listener for keydown
      document.removeEventListener("keydown", this.handleKeyDown);

      // if (this.canvas) {
      //   this.canvas.dispose();
      // }
    }
  
    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // Close modal when Esc key is pressed
        this.handleCloseModal();
      }
    };

  syncSelectedDevice = () => {
    const{Selected_Device_Id} = this.state
    console.log("-----syncSelectedDevice----Selected_Device_Id----", Selected_Device_Id);
  //   // this.LoadSelectedDeviceInfo(Selected_Device_Id)
  //   this.startLoading();
  //   setTimeout(() => {
  //     this.RefreshDeviceInfo().then(() => {
  //         this.stopLoading(); // Stop loading after devices are fetched
  //     });
  // }, 500); // Ensures progress bar is visible before stopping
  this.RefreshDeviceInfo()
  }

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  /** 
   * getCamerasList() function fetches the camera list w.r.t selected device (row from device list table). this function gets invoked from when clicked on the row of device list table.
  **/
  getCamerasList = async (deviceId) => {
    this.setState({ loading: true }, async () => {
    try {
      
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("komal -------------->:", this.state.device_details.recording_policy_days);
      //this.setState({ : [] }); 

      const url = urls.CAMERAS_BY_DEVICE(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await get(url, headers); // Perform the API call using the constructed URL
      if (Array.isArray(response) && response.length > 0) {
        console.log(`API Response for device ${deviceId}:`, response);
        this.setState({ cameras: response, loading: false });

      } else {
        console.error("No valid data returned from the get-camera API");
        this.setState({ cameras: [], loading: false }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      this.setState({ cameras: [], loading: false }); // Clear the cameras list in case of error
    }
  });
  };

  handleSiteSelection = (siteId, siteInfo) => {
    this.setState({ selectedSite: siteId, selectedSiteInfo: siteInfo });
    this.getDevicesListById(siteId);
  };
  

  handleChangePage = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };



  // Handler to toggle dropdown table for a device row // we will use this to load cameras of device
  handleRowClick = async (deviceId) => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    console.log("--------auth tocken---------", access_tocken);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }

    let device_details = await get(urls.DEVICE_DETAILS(deviceId), headers)

    console.log("device_Details", device_details)

    this.setState({
      device_details: device_details
    })


    this.setState(
      (prevState) => ({
        expandedRow: prevState.expandedRow === deviceId ? null : deviceId, // Toggle the row
      }),
      () => {
        if (this.state.expandedRow) {
          this.getCamerasList(deviceId); // Fetch data only when the row is expanded
        }
      }
    );
  };


  update_operator_rating = async (rating) => {
    console.log("update_operator_rating called with:", rating);

    let update_data = {
      operator_rating: rating,
    };

    console.log("Update data being sent:", update_data);

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }
      let response = await post(urls.OPERATOR_RATING(this.state.selectedCamera.id), JSON.stringify(update_data), headers);
      console.log("Response received:", response);

      if (response !== false) {
        console.log("Operator rating updated successfully.");
        // Optionally update the state or provide feedback to the user here
        this.setState({
          selectedCamera: {
            ...this.state.selectedCamera,
            operator_rating: rating,
          },
        });
        this.openSnackbar("Operator rating updated successfully! Please reload to view update.", "success");
      } else {
        console.error("Failed to update operator rating.");
        this.openSnackbar("Error occured while rating the image.", "error");

      }
    } catch (error) {
      console.error("Error while updating operator rating:", error);
    }
  };

  handleCameraRowClick = async (camera) => {
    this.setState(
      (prevState) => ({
        nestedExpandedRow: prevState.nestedExpandedRow === camera.id ? null : camera.id, // Toggle the row
        selectedCamera: camera,
        refreshSystemOverviewstatuscard: !prevState.refreshSystemOverviewstatuscard,
      }),

    );
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    console.log("--------auth tocken---------", access_tocken);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }
    // this.setState({ selectedCamera: camera });
    console.log("cam :- ", camera)
    // fetch cam details for camera id = camera 
    let response = await get(urls.CAMERA_DETAILS(camera.id), headers)
    console.log("response details :- ", response)

    // fetch ref_img img and latest_img img captured by shedule/backend  
    let res_for_img_info = await get(urls.CAMERA_LATEST_IMAGES(camera.id), headers)
    console.log("res2 :", res_for_img_info.length);
    console.log("res2 handleCameraRowClick--:", res_for_img_info);

    if (!res_for_img_info || res_for_img_info.length === 0) {
      console.error("No image data available");
      return;
    }

    // Process images based on capture type
    if (res_for_img_info.length === 1) {

      const image = res_for_img_info[0];
      
      console.log("image",image)

      if (image.capture_type === "ref_img") {
        this.setState({
          ref_img_created_time: image.description,
          ref_img_id: image.id,
        });
        this.set_images("ref_img", image.id);
      } else if (image.capture_type === "latest_img") {
        this.setState({
          latest_img_taken_at: image.description,
        });
        this.set_images("latest_img", image.id);
      }
    } 
      else if (res_for_img_info.length === 2) {
        let refImg = res_for_img_info.find((img) => img.capture_type === "ref_img");
        let latestImg = res_for_img_info.find((img) => img.capture_type === "latest_img");
    
        if (refImg) {
          this.setState({
            ref_img_created_time: refImg.description,
            ref_img_id: refImg.id,
          });
          this.set_images("ref_img", refImg.id);
        }
    
        if (latestImg) {
          this.setState({
            latest_img_taken_at: latestImg.description,
          });
          this.set_images("latest_img", latestImg.id);
        }
      }
      console.log("State updated successfully");

    
  }

  set_images = async (type, img_id) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);

      const response = await axios.get(urls.SERVE_REFERENCE_IMAGE(img_id), {
        responseType: "blob", // Ensures the response is treated as binary data
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': `Bearer ${access_tocken}`
        },
      });

      // Create an object URL from the blob
      const imageURL = URL.createObjectURL(response.data);

      // Update the state with the image blob
      this.setState({
        capturedImageBlob: response.data, // Store blob for uploading
      });

      if (type === 'ref_img') {
        // Update the state with the new image URL
        this.setState((prevState) => ({
          selectedCamera: {
            ...prevState.selectedCamera,
            image1: imageURL,
          },
        }));
      }
      else {
        // Update the state with the new image URL
        this.setState((prevState) => ({
          selectedCamera: {
            ...prevState.selectedCamera,
            image2: imageURL,
          },
        }));
        // Convert Blob to Data URL
      //   const reader = new FileReader();
      //   reader.readAsDataURL(response.data);
      //   reader.onloadend = () => {
      //     const base64DataURL = reader.result; // Get base64 string
      //     this.setState({ imageURL: base64DataURL }, () => {
      //       this.setImageAsCanvas(imageURL); // Set background image
      //     });        
      // }
    }
      // console.log("Snapshot fetched and set:", imageURL);
      //console.log("Snapshot fetched and set:", imageURL);
    } catch (error) {
      console.error("Error fetching snapshot:", error);
    }
  }

  // Toggle collapsible function
  handleToggle = (section) => {
    this.setState((prevState) => ({
      activeSection: prevState.activeSection === section ? null : section,
    }));
  };

  openSnackbar = (msg, alert_type = 'warning' || 'success' || 'error' || 'info') => {
    this.setState({
      open_snackbar: true,
      snackbar_msg: msg,
      alert_type: alert_type,
    })
  }

  // set 
  // Function to fetch the snapshot and set it as the camera image
  capture_snapshot = async () => {
    console.log("Device info:", this.state.device_details);
    let data = {
      ip_address: this.state.device_details.ip_address,
      protocol: this.state.device_details.protocol?.toLowerCase().replace('://', ''), // Convert to lowercase and remove '://'
      port_number: String(this.state.device_details.port_number), // Ensure port_number is a string
      device_username: this.state.device_details.device_username,
      device_password: this.state.device_details.device_password,
      channel_id: String(this.state.selectedCamera.channel_id), // Ensure channel_id is a string
    };

    console.log("Request payload:", data);

    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      const response = await axios.post(
        urls.SNAPSHOT_BY_DATA, // API URL
        data, // Payload (data object)
        {
          responseType: "blob", // Ensures the response is treated as binary data
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${access_tocken}`
          }
        }

      );
      this.stopLoading();

      // Access the custom header from the response
      console.log("Response headers:", response.headers);
      const currentTime = response.headers["x-current-time"];
      console.log("Current Time from API:", currentTime);
      this.setState({ currentTime_of_device: currentTime })

      // Create an object URL from the blob
      const imageURL = URL.createObjectURL(response.data);

      // Update the state with the image blob
      this.setState({
        capturedImageBlob: response.data, // Store blob for uploading
        ref_img_created_time: currentTime,
      });


      // Update the state with the new image URL
      this.setState((prevState) => ({
        selectedCamera: {
          ...prevState.selectedCamera,
          image1: imageURL,
        },
      }));
      
      console.log("Snapshot fetched and set:", imageURL);
      //alert("Reference image captured successfully!");
      this.openSnackbar("Reference image captured successfully!", 'success')
    } catch (error) {
      console.error("Error fetching snapshot:", error);
      this.openSnackbar("Failed to capture the reference image. Please try again.", 'error');
    }
  };


  // Function to save the captured snapshot as a reference image
  save_reference_image = async () => {
    const { selectedCamera, capturedImageBlob } = this.state;

    if (!selectedCamera || !capturedImageBlob) {
      console.error("Camera ID or captured image is missing!");
      return;
    }

    try {
      // Prepare FormData for API request
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const formData = new FormData();
      formData.append("camera", selectedCamera.id); // Ensure camera ID is passed
      formData.append("image", capturedImageBlob, "snapshot.jpg"); // Attach image blob
      formData.append("capture_type", "ref_img"); // Optional description
      formData.append("description", this.state.currentTime_of_device); // Attach current timestamp
      console.log("Sending FormData:", formData);

      const response = await axios.post(urls.REFERENCE_IMAGE_LIST, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': `Bearer ${access_tocken}`
        },
      });

        // Handle success
        // this.setState({ successMessage: "Reference image saved successfully!" });
        // console.log("Reference image saved:", response.data);
        this.stopLoading();
      this.openSnackbar("Reference image saved successfully!", 'success');
        this.setState({
        ref_img_created_time: response.data.description,//response.data.created_at,
      });
      // setTimeout(() => {
      //    window.location.reload();
      //   // this.handleRowClick(this.state.Selected_Device_Id);
      // }, 3000); // 3 seconds delay

    } catch (error) {
      // Handle error
      this.setState({
        errorMessage: "Failed to save reference image. Please try again.",
      });
      console.error("Error saving reference image:", error);
      this.openSnackbar("Reference image not saved !", 'error')
    }
  };

  capture_Latest_Img_snapshot_Manually = async () => {
    console.log("Device info in Latest_Img_snapshot:", this.state.device_details);

    let data = {
      ip_address: this.state.device_details.ip_address,
      protocol: this.state.device_details.protocol?.toLowerCase().replace('://', ''),
      port_number: String(this.state.device_details.port_number),
      device_username: this.state.device_details.device_username,
      device_password: this.state.device_details.device_password,
      channel_id: String(this.state.selectedCamera.channel_id),
    };

    console.log("Request payload in Latest_Img_snapshot:", data);

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      this.startLoading();
      const response = await axios.post(
        urls.SNAPSHOT_BY_DATA,
        data,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${access_tocken}`,
          },
        }
      );
      this.stopLoading();

      const currentTime = response.headers["x-current-time"];
      const imageURL = URL.createObjectURL(response.data);

      // Sequentially update state variables
      await new Promise((resolve) => {
        this.setState(
          {
            capturedLatestImageBlob: response.data, // Store blob for uploading
            selectedCamera: {
              ...this.state.selectedCamera,
              image2: imageURL,
            },
            latest_img_taken_at: currentTime,
          },
          resolve // Ensure state is updated before proceeding
        );
      });
      

      console.log("Snapshot in Latest_Img_snapshot fetched and set:", imageURL);
      this.openSnackbar("Latest image captured successfully!", 'success');

      // Now safely call the save function
      await this.save_Manually_captured_Latest_image();
    } catch (error) {
      console.error("Error fetching snapshot:", error);
      this.openSnackbar("Failed to capture the latest image. Please try again.", 'error');
    }
  };

  save_Manually_captured_Latest_image = async () => {
    const { selectedCamera, capturedLatestImageBlob, latest_img_taken_at } = this.state;

    if (!selectedCamera || !capturedLatestImageBlob) {
      console.error("Camera ID or captured image is missing!");
      return;
    }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const formData = new FormData();
      formData.append("camera", selectedCamera.id);
      formData.append("image", capturedLatestImageBlob, "snapshot.jpg");
      formData.append("capture_type", "latest_img");
      formData.append("description", latest_img_taken_at);

      console.log("Sending FormData:", formData);

      const response = await axios.post(urls.REFERENCE_IMAGE_LIST, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': `Bearer ${access_tocken}`,
        },
      });

      console.log("Latest image saved:", response.data);
      this.setState({
        successMessage: "Latest image saved successfully!",
        latest_img_taken_at: response.data.description,
        // latest_img_taken_at: response.data.updated_at, //debugging step as time format shown is different
      });
    } catch (error) {
      this.setState({
        errorMessage: "Failed to save reference image. Please try again.",
      });
      console.error("Error saving reference image:", error);
    }
  };


  handleDeleteCamera = async (selected_camera_id) => {

    const userConfirmed = window.confirm('Are you sure you want to remove this camera?');

    if (!userConfirmed) {
      return; // If the user clicks "Cancel" in the confirmation dialog, abort the delete operation
    }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      const url = urls.DEVICE_DETAILS(selected_camera_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'content-Type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`,
        },

      });
      console.log("reponse in delete elevator ------------->", response);
      if (response.ok) {

        //   console.log("reponse.ok ------------->", response.ok);

        // const data =  response.json(); 
        console.log(`Elevator with id ${selected_camera_id} deleted successfully`, response);
        // window.location.reload();
        // this.getCamerasList(selected_camera_id);
      }
      else {
        const errorMessage = response.statusText; // Read the error message from response body
        alert(`Failed to delete user with ID ${selected_camera_id}: ${errorMessage}`);

      }
    } catch (error) {
      console.error('Error during delete request:', error);
    }

  }

  openDialog = () => {
    this.setState({
      confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to save the new reference image? This will overwrite the existing image.",
      },
    });
  };

  closeDialog = () => {
    this.setState({
      confirmDialog: {
        ...this.state.confirmDialog,
        isOpen: false,
      },
    });
  };


  handleCameraSchedule = (deviceId) => {
    console.log("handleCameraSchedule---cameraId---", deviceId)
    localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
    //navigate to system-manager/scheduler by navigation
    this.props.navigate("/system-overview/scheduler");
  }


  toggleMuteUnmuteDIalogue = (CameraId) => {
    this.setState({
      open_MuteUnmute_Dialogue : true,
      selectedCameraId: CameraId // Store the selected camera ID in state
    });
    console.log("selected cam id---toggleMuteUnmuteDIalogue-----",CameraId );
  }

  handleMuteUnmuteCameraNotifications = async (CameraId) => {
    console.log("selected cam id---handleMuteUnmuteCameraNotifications-----", CameraId);
    // const{selectedCameraId} = this.state
    // console.log("selectedCameraId-----", selectedCameraId);

    let data = {
      "mute": this.state.mute,
    }
    let post_data = JSON.stringify(data)
    console.log("data---MuteUnmute----", post_data);


    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      // console.log("--------auth tocken---------", access_tocken);
      let headers = {
        // 'content-type': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${access_tocken}`
      }
      // Call custom get method
     let  url = urls.CAMERA_NOTIFICATIONS_MUTE_UNMUTE(CameraId)
      console.log("url---MuteUnmute----", url);

      let response1 = await post(urls.CAMERA_NOTIFICATIONS_MUTE_UNMUTE(CameraId), post_data, headers)
      console.log('res-------->', response1);
      this.setState({
        muteResponseMessage: response1.message,
        success2: true
      });
    }
    catch (error) {
      console.error('Error:', error);
    }

  }

  // Method to handle modal close
  handleCloseModal = () => {
    const {Selected_Device_Id} = this.state
    this.setState({ open_MuteUnmute_Dialogue: false, success2:false, success: false }, () => {
      this.cameraSync()
      console.log("-----close mute modal----");
    });
 
  };

  // getCurrentTimeInDeviceTimezone = (deviceUtcOffset) => {
  //   if (deviceUtcOffset === undefined || deviceUtcOffset === null) {
  //     return "N/A"; // Fallback message
  //   }
  //   try {
  //     // Ensure deviceUtcOffset is in hours; convert to minutes if needed
  //     const offsetMinutes = deviceUtcOffset * 60;

  //     // Get the current UTC time
  //     const now = new Date();

  //     // Calculate the device's local time
  //     const deviceTime = new Date(now.getTime() + offsetMinutes * 60 * 1000);

  //     // Return the device's local time as a readable time string
  //     // return deviceTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }); 
  //     return deviceTime.toLocaleString(); //Show data and time
  //   } catch (error) {
  //     console.error("Error calculating device time:", error);
  //     return "Error calculating time";
  //   }
  // };

  getCurrentTimeInDeviceTimezone = (timezone ) => {
    try {
        // Get the current time in the specified timezone
        const localTime = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true, // Use 12-hour format
        }).format(new Date());

        return localTime;
    } catch (error) {
        console.error("Error calculating device time:", error);
        return "Error calculating time";
    }
};

getCurrentTimeInPosixTz = (posixTz) => {
  try {
      if (!posixTz) return "-";

      // Convert POSIX to IANA timezone (e.g., EST5EDT -> America/Detroit)
      const ianaTimezone = "America/Detroit"; // Manually mapping for accuracy

      // Get the current time in that timezone
      const dt = DateTime.now().setZone(ianaTimezone);

      // Format: "7/2/2025 at 08:30 AM"
      const formattedTime = dt.toFormat("MM/dd/yyyy',' hh:mm a");

      return formattedTime;
  } catch (error) {
      console.error("Error calculating time:", error);
      return "Error calculating time";
    }
};

  handleUnmuteAlert = () => {
    this.setState({
      success: true
    });

  }

  deleteReferenceImage = async () => {
    try {
      const { ref_img_id } = this.state
      let url = (urls.REFERENCE_IMAGE_DETAIL(ref_img_id))
      console.log("---deleteReferenceImage--url---------", url);
      let response = await del(urls.REFERENCE_IMAGE_DETAIL(ref_img_id))
      // let response = await del(urls.REFERENCE_IMAGE_DETAIL(0))
      console.log("----deleteReferenceImage----res----", response);
      if (response) {
        this.openSnackbar("Reference image deleted successfully!", 'success');
          // setTimeout(() => {
          //    window.location.reload();
          //   // this.handleRowClick(this.state.Selected_Device_Id);
          // }, 3000); // 3 seconds delay
      }
      else if (response && response.error === "Reference image not found") {
        this.openSnackbar("Reference image not found!", "error");
      } else if (response === false) {
        this.openSnackbar("Failed to delete reference image. Reference image not found.", "error");
      } else {
        this.openSnackbar("An unexpected error occurred.", "error");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      this.openSnackbar("Failed to delete reference image. Please try again.", "error");

    }
  }



  // ---------------------------Add Site Functions---------------------------------------------------------
  
      handleInputChange = (e) => {
          const { name, value } = e.target;
          this.setState({ [name]: value });
      };
  
      
  
      startLoading = () => {
          console.log("startloading")
      
          this.setState({ open_progress_bar: true })
      }
      
      stopLoading = () => {
          this.setState({ open_progress_bar: false })
      }

      
  //-------------------------------------------------------------------------------------------------------
 //------------------ get device info----------------------------------------------------------------------
   LoadSelectedDeviceInfo = async () => {
    //  this.setState({ editToggle: true });
    console.log("--------deviceId---------", this.state.Selected_Device_Id);
     try {
       let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
       console.log("--------auth tocken---------", access_tocken);
       let headers = {
           'content-type': 'application/json',
           'Authorization': `Bearer ${access_tocken}`
       }
       const url = urls.DEVICE_DETAILS(this.state.Selected_Device_Id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
       const response = await get(url, headers); // Perform the API call using the constructed URL
       console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
 
       if (response && Object.keys(response).length > 0) {
         console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
         this.setState({ 
          devices:response
          });
 
       } else {
         console.error("No valid data returned from the get-camera API");
       }

       this.handleRowClick(this.state.Selected_Device_Id);

     } catch (error) {
       console.error("Error fetching cameras from API:", error);
     }
   };

   RefreshDeviceInfo = async () => {
    const { devices } = this.state;
    console.log("--------device---------", devices);
    let deviceData = {
      "device_name": devices.device_name,
      "device_type": devices.device_type,
      "sitedb": devices.sitedb,
      "ip_address": devices.ip_address,
      "protocol": devices.protocol, // Convert to lowercase and remove '://'
      "port_number": devices.port_number,
      "device_username": devices.device_username,
      "device_password": devices.device_password,
      "rtsp_port": devices.rtsp_port,
      "policy_template_id": devices.recording_policy
      };
      const data = JSON.stringify(deviceData)
      console.log("--------deviceData---------", data);
     try {
      this.startLoading()
       let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
       console.log("--------auth tocken RefreshDeviceInfo---------", access_tocken);
       let headers = {
           'content-type': 'application/json',
           'Authorization': `Bearer ${access_tocken}`
       }
      //  const url = urls.REFRESH_DEVICE;  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
       const response = await post(urls.REFRESH_DEVICE, data, headers); // Perform the API call using the constructed URL
       console.log(`API Response for RefreshDeviceInfo:`, response);
       if (response && response.responseMessage === "Device creation in progress!") {
        setTimeout(() => {
          this.LoadSelectedDeviceInfo();
          this.stopLoading();
        }, 5500); // 1 seconds delay
       
       }
       
       if (response == false){
        this.stopLoading();
        this.openSnackbar("Failed to refresh the device. Please try again.", 'error')
        }
      //  if (response && Object.keys(response).length > 0) {
      //    console.log(`API Response for RefreshDeviceInfo:`, response);
      //    this.setState({ 
      //     devices:response
      //     });
 
      //  } else {
      //    console.error("No valid data returned from the get-camera API");
      //  }
     } catch (error) {
       console.error("Error fetching cameras from API:", error);
     }
   }

   //--------------------------------------------------------------------------------------------

   //------------Template Update----------------------------------------------------------------

   handleTemplateUpdate = () => {
    this.setState({templateEditToggle : true});
   }

   closeTemplateUpdate = () => {
    this.setState({templateEditToggle : false});
   }

   handleFetchTemplate = async() => {
   
      try{
          let response = await get(urls.HEALTH_RECORDING_POLICY);
          console.log("FetchTemplate API Response:", response)
          if (response) {
              console.log("res",response)
              this.setState({ template_list: response });
          } else {
              console.error("No data returned from the API");
              this.setState({ template_list: [] });
          }
      }

      catch (error) {
          console.error("Error fetching devices from API:", error);
      }
  }

  handleUpdateTemplate = async() => {
      const{ template_name, Selected_Device_Id} = this.state;
      // Validation for required fields
      if (!template_name) {
          this.setState({ warning: true });
          setTimeout(() => {
            this.setState({warning:false});
          }, 4500);
          return;
      }
        let post_data = {
                  "device_ids" : [Selected_Device_Id],
                  "recording_policy_id" : template_name,
              }
      
              post_data = JSON.stringify(post_data);
              console.log("------post-data in SaveTemplate---", post_data);
      
              try{
                  let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
                  console.log("--------auth tocken---------", access_tocken);
                  let headers = {
                      // 'content-type': 'application/json',
                      'Content-Type': 'application/json; charset=UTF-8',
                      'Authorization': `Bearer ${access_tocken}`
                  }
                  let response = await post(urls.SET_TEMPLATE_TO_MULTIPLE_DEVICES, post_data, headers);
                  console.log("API Response:", response)
                  if(response && response.error==="device_ids and recording_policy_id are required."){
                      // this.setState({ warning: true});
                      this.openSnackbar("device_ids and recording_policy_id are required.", 'warning')

                      console.log("res",response);
                  }else if (response && response.error!=="device_ids and recording_policy_id are required.") {
                      // this.setState({ success: true, Responsemessage: response.message });
                      this.openSnackbar("New Recording policy template is applied successfully!", 'success')
                      setTimeout(() => {
                          window.location.reload();
                      }, 3500); // 3 seconds delay

                  }
                    else {
                      console.error("No response returned from the API");
                      this.openSnackbar("Server Error!", 'success')
                      // this.setState({ error: true });
                      // setTimeout(() => {
                      //     window.location.reload();
                      // }, 3000); // 3 seconds delay
                  }
              }
      
              catch (error) {
                  console.error("Error fetching devices from API:", error);
              }
  }

  cameraSync = () => {
    const{Selected_Device_Id}=this.state
    this.setState({ open_MuteUnmute_Dialogue: false })
    console.log("-----cameraSync----Selected_Device_Id", Selected_Device_Id);
    this.startLoading();
    // Delay for alert visibility before reload
    // this.handleRowClick(Selected_Device_Id);
    // this.stopLoading();

    setTimeout(() => {
      this.handleRowClick(Selected_Device_Id).then(() => {
          this.stopLoading(); // Stop loading after devices are fetched
      });
  }, 500); // Ensures progress bar is visible before stopping
  }

  // --------------------ignore zone draw img -------------------
  

  //-------------------------------------------------------------------------------

  toggleIgnoreZoneSection = () => {
    this.setState({toggleIgnoreZone:true});
  }

  closeIgnoreZoneSection = () => {
    this.setState({toggleIgnoreZone:false});
  }

  // getHDDColor = (storage) => {
  //   if (!storage) return "black"; // Default color in case of missing data
  
  //   const [used, total] = storage.split("/").map(value => parseFloat(value));
  //   if (isNaN(used) || isNaN(total) || total === 0) return "black"; // Handle edge cases
  
  //   const usedPercentage = (used / total) * 100;
  
  //   return usedPercentage < 80 ? "green" : "red"; // Green if < 80%, Red if ≥ 80%
  // };

  getHDDColor = (totalFreeSpace, totalSpace) => { //new func to show color based on addition of free space of all hdd
    if (!totalFreeSpace && !totalSpace) return "black"; // Default color in case of missing data
  
    // const [used, total] = storage.split("/").map(value => parseFloat(value));
    if (isNaN(totalFreeSpace) || isNaN(totalSpace) || totalSpace === 0) return "black"; // Handle edge cases
  
    const usedPercentage = (totalFreeSpace / totalSpace) * 100;
  
    return usedPercentage < 80 ? "green" : "red"; // Green if < 80%, Red if ≥ 80%  totalFreeSpace, totalSpace
  };

  toggleDetails = () => { //state change to show all hdd data onclick of 'i' icon
    this.setState((prevState) => ({
      showDiskDetails: !prevState.showDiskDetails,
    }));
  };

  render() {
    const { devices, cameras, loading, currentPage, rowsPerPage, searchInput, expandedRow, selectedCamera, activeSection, confirmDialog, open_MuteUnmute_Dialogue, error2, success2, nestedExpandedRow } = this.state;

    const {toggleAddSite, sitename, address, city, street, zip, state, organisationName, warning_site, success_site, error_site, client_list,
      selected_Customers , country, SiteName,  DeviceName, user_type, templateEditToggle, selectedCameraId} = this.state;

    // const { devices } = this.props;
    const { activeTab, template_list, template_name, toggleIgnoreZone } = this.state;

    // Ensure devices is an array
    // const filtered_Devices = (Array.isArray(devices) ? devices : []).filter((device) =>
    //   device.device_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );

    // Ensure cameras is an array
    // const filteredCameras = (Array.isArray(cameras) ? cameras : []).filter((camera) =>
    //   camera.camera_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );

    // const filtered_Sites = (Array.isArray(site_list) ? site_list : []).filter((site) =>
    //   site.sitename?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );

    // console.log(devices.hard_disks,"len");

    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    // const currentRows = filtered_Devices.slice(indexOfFirstRow, indexOfLastRow);
    // const currentSites = filtered_Sites.slice(indexOfFirstRow, indexOfLastRow);
    // const currentCamRows = filteredCameras.slice(indexOfFirstRow, indexOfLastRow);


    return (
      <div style={{ height: "100vh", overflow: "hidden" }}>
        {/* Navigation Bar */}
        <Navigationbar />

        <div
          style={{
            backgroundColor: "#fafafa",
            display: "flex",
            flexDirection: "column",
            marginLeft: "3%",
          }}
        >
          {/* Main Content with Flexbox Layout */}
          <Box
            sx={{
              display: "flex",
              marginLeft: "6.2%",
              marginRight: "2%",
              marginTop: "0.5%",
              backgroundColor: "#fafafa",
              height: "35px",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                display: "flex",
                height: "100%",
                alignItems: "center",
                paddingLeft: "10px",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                display="flex"
                alignItems="center"
              >
                <Link to="/showDevices"> Sites</Link>{" "}
                <KeyboardArrowRightIcon fontSize="large" color="primary" />{" "}
                {SiteName}{" "}
                <KeyboardArrowRightIcon fontSize="large" color="primary" />{" "}
                {DeviceName}
              </Typography>
            </TableContainer>
          </Box>
          {/* Main  Content Layout */}
          <Box
            sx={{
              display: "flex",
              marginLeft: "5%",
              backgroundColor: "#fafafa",
            }}
          >
            {/* Main device Content Area */}
            <Box
              sx={{
                flexGrow: 1, // Occupy remaining horizontal space
                padding: "16px",
                minWidth: 0, // Prevent content overflow
                height: "88vh",
                overflowY: "scroll",
                "&::WebkitScrollbar": {
                  width: "8px", // Adjust scrollbar thickness
                },
                "&::WebkitScrollbarThumb": {
                  backgroundColor: "#aaa", // Color of the scrollbar thumb
                  borderRadius: "4px", // Rounded corners for the thumb
                },
                "&::WebkitScrollbarThumb:hover": {
                  backgroundColor: "#888", // Color when hovered
                },
                scrollbarWidth: "1px", // Adjust scrollbar thickness in Firefox
                scrollbarColor: "#aaa #f0f0f0",
              }}
            >
              {/* Subtab Bar */}
              <Tabs
                value={activeTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                component={Paper}
              >
                <Tab
                  label="General Info"
                  sx={{
                    backgroundColor:
                      activeTab === 0 ? "#d1e8ff" : "transparent",
                    color: activeTab === 0 ? "#000" : "inherit",
                    fontWeight: activeTab === 0 ? 550 : 500,
                  }}
                />
                <Tab
                  label="Scheduler"
                  sx={{
                    backgroundColor:
                      activeTab === 1 ? "#d1e8ff" : "transparent",
                    color: activeTab === 1 ? "#000" : "inherit",
                    fontWeight: activeTab === 1 ? 550 : 500,
                  }}
                />
                <Tab
                  label="Recording Template Setting"
                  sx={{
                    backgroundColor:
                      activeTab === 2 ? "#d1e8ff" : "transparent",
                    color: activeTab === 2 ? "#000" : "inherit",
                    fontWeight: activeTab === 2 ? 550 : 500,
                  }}
                />
              </Tabs>
              <>
                {/* Tab Content */}
                <Box sx={{ marginTop: 0.5 }}>
                  {activeTab === 0 && (
                    <>
                      <div style={{ display: "flex", justifyContent: "right" }}>
                        <img
                          src={SyncIcon1}
                          alt="sync-icon"
                          width="50px"
                          onClick={this.syncSelectedDevice}
                          title="Sync Device"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <TableContainer component={Paper}>
                        <Table style={{ tableLayout: "fixed", width: "100%" }}>
                          <TableHead>
                            <TableRow>
                              {[
                                "Group Name",
                                "Site Name",
                                "HDD Storage (Used/Total)",
                                "System Channel Max",
                                "Active Cameras",
                                "Current Site Time",
                                "Current Device Time",
                                "Online",
                                "Storage Health",
                                "IP Address",
                              ].map((header) => (
                                <TableCell key={header} align="center">
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight="bold"
                                  >
                                    {header}
                                  </Typography>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {devices && (
                              <React.Fragment key={devices.id}>
                                <TableRow>
                                  <TableCell align="center">
                                    {devices.device_name}
                                  </TableCell>
                                  <TableCell align="center">
                                    {devices.site_name || "N/A"}
                                  </TableCell>
                                  {/* <TableCell align="center">{devices.hdd_storage}</TableCell> */}
                                  {/* <TableCell align="center">
                                    {" "}
                                    {devices && devices.hard_disks ? (
                                      <div>
                                        {devices.hard_disks.map((disk) => {
                                          return (
                                            <p
                                              style={{
                                                color: this.getHDDColor(
                                                  disk.free_total_ratio
                                                ),
                                              }}
                                            >
                                              {disk.free_total_ratio}
                                            </p>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      devices.hdd_storage
                                    )}
                                  </TableCell> */}
                                                                  <TableCell align="center" >
                                                                    {devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length > 0 ? (
                                                                      <div >
                                                                        {(() => {
                                                                          const totalFreeSpace = devices.hard_disks.reduce(
                                                                            (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0),
                                                                            0
                                                                          );
                                  
                                                                          const totalSpace = devices.hard_disks.reduce(
                                                                            (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0),
                                                                            0
                                                                          );
                                  
                                                                          return (
                                                                            <>
                                                                              <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                                                                                <span style={{ color: this.getHDDColor(totalFreeSpace, totalSpace) }}>
                                                                                  {totalFreeSpace.toFixed(2)}/{totalSpace.toFixed(2)}
                                                                                </span>
                                                                                <IconButton onClick={this.toggleDetails} size="small">
                                                                                  <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                                                                </IconButton>
                                                                              </div>
                                                                              {this.state.showDiskDetails && (
                                                                                <div>
                                                                                  {devices.hard_disks.map((disk) => (
                                                                                    <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb) }}>
                                                                                      hdd{disk.disk_id}:{disk.free_space_gb}/
                                                                                      {disk.total_space_gb}
                                                                                    </p>
                                                                                  ))}
                                                                                </div>
                                                                              )}
                                                                            </>
                                                                          );
                                                                        })()}
                                                                      </div>
                                                                    ) : (
                                                                      <p>{devices.hdd_storage || "No Storage Info"}</p>
                                                                    )}
                                                                  </TableCell>
                                  <TableCell align="center">
                                    {devices.chl_max_count}
                                  </TableCell>
                                  <TableCell align="center">
                                    {devices.total_cameras}
                                  </TableCell>
                                  <TableCell align="center">
                                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <Box
                                      color={
                                        devices.timezone_match ? "green" : "red"
                                      }
                                    >
                                      {/* {this.getCurrentTimeInDeviceTimezone(devices.site_timezone)} */}
                                      {this.getCurrentTimeInDeviceTimezone(
                                        devices.site_timezone
                                      )}
                                    </Box>
                                    {devices.site_timezone && (
                                        <Tooltip
                                          title={
                                            `Timezone: ${devices.site_timezone}`
                                          }
                                        >
                                          <InfoOutlinedIcon
                                            fontSize="small"
                                            sx={{ ml: 0.5 }}
                                          />
                                        </Tooltip>
                                      )}
                                      </div>
                                  </TableCell>
                                  <TableCell align="center">
                                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                    <Box
                                      color={
                                        devices.timezone_match ? "green" : "red"
                                      }
                                    >
                                      
                                      {devices.current_time}
                                    </Box>
                                    {devices.current_time && (
                                      <Tooltip
                                        title={
                                          `Timezone: ${devices.current_time}`
                                        }
                                      >
                                        <InfoOutlinedIcon
                                          fontSize="small"
                                          sx={{ ml: 0.5 }}
                                        />
                                      </Tooltip>
                                    )}
                                    </div>
                                  </TableCell>

                                  <TableCell align="center">
                                    <Tooltip
                                      title={
                                        devices.status === "active"
                                          ? "Device is active"
                                          : "Device is inactive"
                                      }
                                    >
                                      {devices.status === "active" ? (
                                        <CheckCircleIcon color="success" />
                                      ) : (
                                        <CancelIcon color="error" />
                                      )}
                                    </Tooltip>
                                  </TableCell>
                                  {/* <TableCell align="center">
                                    {devices && devices.hard_disks ? (
                                      <div>
                                        {devices.hard_disks.map((disk) => {
                                          return (
                                            <Tooltip
                                              title={
                                                disk.status === "RW" || disk.status === "read/write"
                                                  ? "Storage is healthy"
                                                  : "Storage has issues"
                                              }
                                            >
                                              {disk.status === "RW" || disk.status === "read/write" ? (
                                                <div>

                                                  <CheckCircleIcon color="success" />
                                                </div>
                                              ) : (
                                                <div>

                                                  <CancelIcon color="error" />
                                                </div>
                                              )}
                                            </Tooltip>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <Tooltip
                                        title={
                                          devices.storage_health === "Ok"
                                            ? "Storage is healthy"
                                            : "Storage has issues"
                                        }
                                      >
                                        {devices.storage_health === "Ok" ? (
                                          <CheckCircleIcon color="success" />
                                        ) : (
                                          <CancelIcon color="error" />
                                        )}
                                      </Tooltip>
                                    )}
                                  </TableCell> */}
                                  <TableCell align="center">
                                    {devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length > 0 ? (() => {
                                      // Check if all hard disks have status "RW"
                                      const allHealthy = devices.hard_disks.every(disk => disk.status === "RW" || disk.status === "read/write");

                                      return (
                                        <div>
                                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <Tooltip title={allHealthy ? "All disks are healthy" : "One or more disks have issues"}>
                                              {allHealthy ? (
                                                <CheckCircleIcon color="success" />
                                              ) : (
                                                <CancelIcon color="error" />
                                              )}
                                            </Tooltip>
                                            {/* Info icon to toggle hard disk details */}
                                            <IconButton onClick={this.toggleDetails} size="small">
                                              <InfoOutlinedIcon fontSize="small" />
                                            </IconButton>
                                          </div>

                                          {/* Show details of each hard disk when toggled */}
                                          {this.state.showDiskDetails && (
                                            <div style={{ marginTop: "5px" }}>
                                              {devices.hard_disks.map((disk) => (
                                                <div key={disk.disk_id} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                  <span>hdd{disk.disk_id}:</span>
                                                  <Tooltip title={disk.status === "RW" || disk.status === "read/write" ? "Healthy" : "Issue detected"}>
                                                    {disk.status === "RW" || disk.status === "read/write" ? (
                                                      <CheckCircleIcon color="success" />
                                                    ) : (
                                                      <CancelIcon color="error" />
                                                    )}
                                                  </Tooltip>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })() : (
                                      <Tooltip title={devices?.storage_health === "Ok" ? "Storage is healthy" : "Storage has issues"}>
                                        {devices?.storage_health === "Ok" ? (
                                          <CheckCircleIcon color="success" />
                                        ) : (
                                          <CancelIcon color="error" />
                                        )}
                                      </Tooltip>
                                    )}
                                  </TableCell>

                                  <TableCell
                                    align="center"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {/* <IconButton
                                        component="a"
                                        href={`${devices.protocol}://${devices.ip_address}:${devices.port_number}`}
                                        target="_blank"
                                    >
                                        <LinkIcon />
                                    </IconButton> */}
                                    <a
                                      component="a"
                                      href={`${devices.protocol}://${devices.ip_address}:${devices.port_number}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img
                                        src={LinkIcon}
                                        alt="ip-globe"
                                        width="26px"
                                        title="Click here to go to the address"
                                        style={{ cursor: "pointer" }}
                                      />
                                    </a>
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  )}
                  {activeTab === 1 && (
                    <Box component={Paper}>
                      {" "}
                      <Scheduler />{" "}
                    </Box>
                  )}
                  {activeTab === 2 && (
                    <Box>
                      {templateEditToggle ? (
                        <TableContainer component={Paper}>
                          <Table
                            style={{ tableLayout: "fixed", width: "100%" }}
                          >
                            <TableHead>
                              <TableRow>
                                {["Group Name", "Select Template Name", ""].map(
                                  (header) => (
                                    <TableCell key={header}>
                                      <Typography
                                        variant="subtitle2"
                                        fontWeight="bold"
                                      >
                                        {header}
                                      </Typography>
                                    </TableCell>
                                  )
                                )}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {devices && (
                                <React.Fragment key={devices.id}>
                                  <TableRow style={{ cursor: "pointer" }}>
                                    <TableCell>{devices.device_name}</TableCell>
                                    {/* <TableCell> {devices.recording_policy_name} </TableCell> */}
                                    {/* <TableCell>{devices.recording_policy_days}</TableCell>
                                        <TableCell>{devices.hd_capacity_alert}</TableCell> */}
                                    <TableCell>
                                      <select
                                        name="template_name"
                                        value={template_name}
                                        onChange={this.handleInputChange}
                                        style={{
                                          fontFamily: "Arial, sans-serif",
                                          fontSize: "16x",
                                        }}
                                      >
                                        <option value="" disabled>
                                          Select Template to Apply
                                        </option>
                                        {(template_list || []).map((temp) => (
                                          <option key={temp.id} value={temp.id}>
                                            {temp.name}
                                          </option>
                                        ))}
                                      </select>
                                    </TableCell>
                                    <TableCell>
                                      <Button
                                        //  style={{color:'green', border:'1px solid green'}}
                                        id="rowsPerPageButton"
                                        onClick={this.handleUpdateTemplate}
                                      >
                                        Set Template
                                      </Button>{" "}
                                      &ensp;
                                      <Button
                                        //  style={{color:'red', border:'1px solid red'}}
                                        id="clearUserLogButton"
                                        onClick={this.closeTemplateUpdate}
                                      >
                                        cancel
                                      </Button>
                                      &nbsp;
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <TableContainer component={Paper}>
                          <Table
                            style={{ tableLayout: "fixed", width: "100%" }}
                          >
                            <TableHead>
                              <TableRow>
                                {[
                                  "Group Name",
                                  "Applied Template Name",
                                  "Days",
                                  "Percentage for HDD Capicity",
                                  "",
                                ].map((header) => (
                                  <TableCell key={header}>
                                    <Typography
                                      variant="subtitle2"
                                      fontWeight="bold"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {header}
                                      {header ===
                                        "Percentage for HDD Capicity" && (
                                        <Tooltip
                                          title={
                                            "HD capacity percentage (%) that hard-drive can be full before receiving an alert."
                                          }
                                        >
                                          <InfoOutlinedIcon
                                            fontSize="small"
                                            sx={{ ml: 0.5 }}
                                          />
                                        </Tooltip>
                                      )}
                                      {header === "Days" && (
                                        <Tooltip
                                          title={
                                            "Look for recordings from the past so many days."
                                          }
                                        >
                                          <InfoOutlinedIcon
                                            fontSize="small"
                                            sx={{ ml: 0.5 }}
                                          />
                                        </Tooltip>
                                      )}
                                    </Typography>
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {devices && (
                                <React.Fragment key={devices.id}>
                                  <TableRow>
                                    <TableCell>{devices.device_name}</TableCell>
                                    <TableCell>
                                      {" "}
                                      {devices.recording_policy_name}{" "}
                                    </TableCell>
                                    <TableCell style={{ cursor: "default" }}>
                                      {devices.recording_policy_days}
                                    </TableCell>
                                    <TableCell style={{ cursor: "default" }}>
                                      {devices.hd_capacity_alert}%
                                    </TableCell>
                                    <TableCell style={{ cursor: "pointer" }}>
                                      {user_type === "DealerUser" && (
                                        <img
                                          src={EditIcon}
                                          alt="new-edit-icon"
                                          width="30px"
                                          title="Apply New Template"
                                          onClick={this.handleTemplateUpdate}
                                        />
                                      )}
                                    </TableCell>
                                  </TableRow>
                                </React.Fragment>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Box>
                  )}
                </Box>
              </>
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{ color: "#1058a0", paddingLeft: "8px" }}
                  >
                    Cameras
                  </Typography>
                  <img
                    src={SyncIcon}
                    alt="sync-icon"
                    width="50px"
                    onClick={this.cameraSync}
                    title="Refresh Cameras"
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <TableContainer component={Paper}>
                  <Table style={{ tableLayout: "fixed", width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        {[
                          "Camera Name",
                          "Online",
                          "Recording Days",
                          "Operator Rating",
                          "Mute Status",
                          "",
                        ].map((header) => (
                          <TableCell key={header}>
                            <Typography variant="subtitle2" fontWeight={550}>
                              {header}
                            </Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            Loading ...
                          </TableCell>
                        </TableRow>
                      ) : cameras.length > 0 ? (
                        cameras.map((camera) => (
                          <React.Fragment key={camera.id}>
                            <TableRow>
                              <TableCell>{camera.camera_name}</TableCell>
                              <TableCell>
                                <Tooltip
                                  title={
                                    camera.status === "online"
                                      ? "Camera is active"
                                      : "Camera is inactive"
                                  }
                                >
                                  {camera.status === "online" ? (
                                    <CheckCircleIcon color="success" />
                                  ) : (
                                    <CancelIcon color="error" />
                                  )}
                                </Tooltip>
                              </TableCell>
                              <TableCell>
                                {/* <td> */}
                                {camera.recording_days <
                                this.state.device_details
                                  .recording_policy_days ? (
                                  // <span style={{ color: 'red' }}>
                                  <span style={{ color: "red" }}>
                                    {/* <img src={RecordingRed} alt="less-recording" width="35px" height="30"/><br /> */}
                                    {camera.recording_days} /
                                    {this.state.device_details
                                      .recording_policy_days
                                      ? `${this.state.device_details.recording_policy_days} days`
                                      : "No policy defined"}
                                  </span>
                                ) : (
                                  <span style={{ color: "#2e8b57" }}>
                                    {/* <img src={RecordingGreen} alt="less-recording" width="35px" height="30" /><br /> */}
                                    <b>{camera.recording_days} / </b>
                                    <b>
                                      {this.state.device_details
                                        .recording_policy_days
                                        ? `${this.state.device_details.recording_policy_days} days`
                                        : "No policy defined"}
                                    </b>
                                  </span>
                                )}
                              </TableCell>
                              <TableCell>{camera.operator_rating}</TableCell>
                              <TableCell
                                onClick={() =>
                                  this.toggleMuteUnmuteDIalogue(camera.id)
                                }
                              >
                                {camera.mute === "True" ? (
                                  <span>
                                    {/* <img src={MuteNotificationIcon} alt="muted Notification" title="Muted" width="25px"/>  */}
                                    <NotificationsOffIcon
                                      color="error"
                                      titleAccess="Muted"
                                      cursor="pointer"
                                    />
                                  </span>
                                ) : (
                                  <span>
                                    {/* <img src={UnMuteNotificationIcon} alt="muted Notification" title="Unmuted" width="25px"/>  */}
                                    <NotificationsIcon
                                      color="success"
                                      titleAccess="Unmuted"
                                      cursor="pointer"
                                    />
                                  </span>
                                )}
                                {open_MuteUnmute_Dialogue && (
                                  <div className="modal-mute-unmute">
                                    <div className="modal-content-mute-unmute">
                                      <button
                                        className="close-button"
                                        onClick={this.handleCloseModal}
                                      >
                                        &times;
                                      </button>
                                      <div>
                                        <h3 style={{ textAlign: "center" }}>
                                          Update Camera Notification settings
                                        </h3>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <Button
                                            onClick={() =>
                                              this.setState(
                                                { mute: true },
                                                () =>
                                                  this.handleMuteUnmuteCameraNotifications(
                                                    selectedCameraId
                                                  )
                                              )
                                            }
                                            id="rowsPerPageButton"
                                          >
                                            Mute
                                          </Button>{" "}
                                          &ensp;
                                          <Button
                                            // onClick={() => this.setState({ mute: false }, () => this.handleMuteUnmuteCameraNotifications(selectedCameraId))}
                                            onClick={() =>
                                              this.handleUnmuteAlert()
                                            }
                                            id="clearUserLogButton"
                                          >
                                            Unmute
                                          </Button>
                                        </div>
                                        <div style={{ marginTop: "3px" }}>
                                          {error2 ? (
                                            <Alert severity="error">
                                              Server error! Try again later.
                                            </Alert>
                                          ) : success2 ? (
                                            <Alert
                                              icon={
                                                <CheckIcon fontSize="inherit" />
                                              }
                                              severity="success"
                                            >
                                              {this.state.mute
                                                ? "Muted notifications for this camera."
                                                : "Unmuted notifications for this camera."}
                                            </Alert>
                                          ) : this.state.success ? (
                                            <Alert
                                              icon={
                                                <CheckIcon fontSize="inherit" />
                                              }
                                              severity="success"
                                            >
                                              To Unmute this camera, please
                                              Contact Admin !
                                            </Alert>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={(e) => {
                                    // Prevent row click when clicking on the Show More button
                                    //onClick={() => this.handleCameraRowClick(camera)}
                                    e.stopPropagation();
                                    this.handleCameraRowClick(camera);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {nestedExpandedRow === camera.id ? (
                                    <KeyboardArrowUp />
                                  ) : (
                                    <KeyboardArrowDown />
                                  )}
                                  <Typography
                                    variant="body2"
                                    style={{ marginLeft: "8px" }}
                                  >
                                    {nestedExpandedRow === camera.id
                                      ? "Show Less"
                                      : "Show More"}
                                  </Typography>
                                </IconButton>
                              </TableCell>
                            </TableRow>
                            {nestedExpandedRow === camera.id && (
                              <TableRow>
                                <TableCell
                                  colSpan={6}
                                  style={{
                                    padding: "0",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  <div
                                    style={{
                                      padding: "16px",
                                      border: "1px solid #d1d1e8",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      height: "auto",
                                    }}
                                  >
                                    {toggleIgnoreZone ? (
                                      <>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <h3
                                            style={{
                                              color: "#111146",
                                              marginBottom: "16px",
                                            }}
                                          >
                                            Details of Camera:{" "}
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              {camera.camera_name}
                                            </span>
                                          </h3>
                                          <Button
                                            id="rowsPerPageButton"
                                            style={{ height: "25px" }}
                                            onClick={
                                              this.closeIgnoreZoneSection
                                            }
                                          >
                                            Cancel
                                          </Button>
                                        </div>
                                        <div>
                                          <CameraCanvas
                                            imageSrc={selectedCamera.image2}
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <h3
                                            style={{
                                              color: "#111146",
                                              marginBottom: "16px",
                                            }}
                                          >
                                            Details of Camera:{" "}
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              {camera.camera_name}
                                            </span>
                                          </h3>
                                          <Button
                                            id="rowsPerPageButton"
                                            style={{ height: "25px" }}
                                            onClick={
                                              this.toggleIgnoreZoneSection
                                            }
                                          >
                                            Ignore Zone Settings
                                          </Button>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            gap: "5px",
                                          }}
                                        >
                                          {/* Reference Image Section */}
                                          <div
                                            style={{
                                              textAlign: "center",
                                              border:
                                                "0.5px solid rgb(205, 205, 205)",
                                              borderRadius: "4px",
                                              padding: "4px",
                                              width: "30%",
                                              height: "100%",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginBottom: "8px",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#242483",
                                              }}
                                            >
                                              <img
                                                src={MinusIcon}
                                                alt="Remove"
                                                title="Remove Reference Image"
                                                style={{
                                                  width: "40px",
                                                  marginRight: "8px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={
                                                  this.deleteReferenceImage
                                                }
                                              />
                                              <img
                                                src={PlusIcon}
                                                alt="Capture"
                                                title="Capture Reference Image"
                                                style={{
                                                  width: "40px",
                                                  marginRight: "8px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={this.capture_snapshot}
                                              />
                                              <img
                                                src={ExclaimIcon}
                                                alt="Confirm"
                                                title="Confirm Reference Image"
                                                style={{
                                                  width: "40px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={this.openDialog}
                                              />
                                              Reference Image
                                            </div>
                                            <img
                                              src={
                                                selectedCamera.image1 || no_img
                                              }
                                              alt="Camera View 1"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                // borderRadius: '4px',
                                              }}
                                            />
                                            <p>
                                              <b>Image Taken At :</b>{" "}
                                              {this.state.ref_img_created_time}
                                            </p>
                                          </div>

                                          {/* <div style={{display:'flex', justifyContent:'space-between'}}> */}
                                          {/* Image Comparison Section */}
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              textAlign: "center",
                                            }}
                                          >
                                            {selectedCamera.image1 &&
                                            selectedCamera.image2 ? (
                                              selectedCamera.ai_rating ===
                                              "healthy" ? (
                                                <img
                                                  src={SameImageStatus}
                                                  alt="same-image"
                                                  title="Both the images are similar"
                                                />
                                              ) : (
                                                // : selectedCamera.operator_rating === 'not yet rated' ? (
                                                //   <img
                                                //     src={QuestionMarkImage} // Replace with your question mark image variable
                                                //     alt="question-mark"
                                                //     title="Operator has not rated"
                                                //   />
                                                // )
                                                <img
                                                  src={DiffImageStatus} // Default case for "unhealthy" or other values
                                                  alt="diff-img"
                                                  title="Either the images are not similar or not yet rated by operator"
                                                />
                                              )
                                            ) : // : selectedCamera.image1 ? (
                                            //   <img
                                            //     src={QuestionMarkImage}
                                            //     alt="diff-img"
                                            //     title="Images are not similar"
                                            //   />
                                            // )
                                            null}
                                          </div>
                                          {/* Latest Image Section */}
                                          <div
                                            style={{
                                              textAlign: "center",
                                              border:
                                                "0.5px solid rgb(205, 205, 205)",
                                              borderRadius: "4px",
                                              padding: "4px",
                                              width: "30%",
                                              height: "100%",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                color: "#08457e",
                                                marginBottom: "8px",
                                              }}
                                            >
                                              Latest Image
                                              <img
                                                src={PlusIcon}
                                                alt="Capture Latest"
                                                title="Capture Latest Image"
                                                style={{
                                                  width: "40px",
                                                  marginLeft: "8px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={
                                                  this
                                                    .capture_Latest_Img_snapshot_Manually
                                                }
                                              />
                                            </div>
                                            <img
                                              src={
                                                selectedCamera.status ===
                                                "offline"
                                                  ? NoCameraConnected
                                                  : selectedCamera.image2
                                                  ? selectedCamera.image2
                                                  : no_img
                                              }
                                              alt="Camera View 2"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                // borderRadius: '4px',
                                              }}
                                            />
                                            <p>
                                              <b>Image Taken At : </b>
                                              {this.state.latest_img_taken_at}
                                            </p>
                                          </div>
                                          {/* </div> */}

                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "6px",
                                              flex: 1,
                                              marginLeft: "10px",
                                              width: "auto",
                                              height: "100%",
                                            }}
                                          >
                                            {[
                                              {
                                                label: "Is Camera Live ? :",
                                                value: camera.status,
                                                color:
                                                  camera.status === "online"
                                                    ? "green"
                                                    : "red",
                                              },
                                              {
                                                label: "AI Rating : ",
                                                value:
                                                  camera.ai_rating || "N/A",
                                                color:
                                                  camera.ai_rating === "healthy"
                                                    ? "green"
                                                    : "red",
                                              },
                                              {
                                                label: "Operator Rating : ",
                                                value:
                                                  selectedCamera.operator_rating,
                                                color:
                                                  selectedCamera.operator_rating ===
                                                  "healthy"
                                                    ? "green"
                                                    : "red",
                                              },
                                              // { label: 'Port : ', value: camera.port },
                                              {
                                                label:
                                                  "FPS (Main / Sub Stream) : ",
                                                value: `${
                                                  camera.main_stream_fps ||
                                                  "N/A"
                                                } / ${
                                                  camera.sub_stream_fps || "N/A"
                                                }`,
                                              },
                                              {
                                                label:
                                                  "Resolution (Main / Sub Stream) : ",
                                                value: `${
                                                  camera.main_stream_resolution ||
                                                  "N/A"
                                                } / ${
                                                  camera.sub_stream_resolution ||
                                                  "N/A"
                                                }`,
                                              },
                                            ].map((item, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  fontSize: "14px",
                                                  color: "#333",
                                                  lineHeight: "2",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                    marginRight: "4px",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  {item.label}
                                                </span>
                                                <span
                                                  style={{ color: item.color }}
                                                >
                                                  {typeof item.value ===
                                                  "string"
                                                    ? item.value
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      item.value.slice(1)
                                                    : item.value}
                                                </span>
                                              </div>
                                            ))}

                                            <Typography
                                              variant="subtitle1"
                                              fontWeight="bold"
                                              mt={1}
                                            >
                                              Rate Current Camera's Image{" "}
                                              <span>&#10147;</span>
                                            </Typography>

                                            {/* </button> */}
                                            {/* {activeSection === 'rate' && ( */}
                                            <div
                                              style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                  "repeat(3, 1fr)",
                                                marginBottom: "10px",
                                                justifyContent: "space-between",
                                                gap: "8px",
                                              }}
                                            >
                                              {/* Button list */}
                                              {[
                                                "healthy",
                                                "blur",
                                                "tilt",
                                                "block",
                                                "fault",
                                                "low light",
                                              ].map((rating) => (
                                                <button
                                                  key={rating}
                                                  className={`RatingButtons ${
                                                    rating === "healthy"
                                                      ? "healthy"
                                                      : "other"
                                                  }`}
                                                  style={{
                                                    backgroundColor:
                                                      selectedCamera.operator_rating ===
                                                      rating
                                                        ? rating === "healthy"
                                                          ? "#77dd77" // Green for healthy
                                                          : "#e51a4c" // Red for others
                                                        : "", // Default styling
                                                    color:
                                                      selectedCamera.operator_rating ===
                                                      rating
                                                        ? "white"
                                                        : "", // White text for selected button
                                                  }}
                                                  onClick={() =>
                                                    this.update_operator_rating(
                                                      rating
                                                    )
                                                  }
                                                >
                                                  {/* {rating} */}
                                                  {typeof rating === "string"
                                                    ? rating
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      rating.slice(1)
                                                    : rating}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            align="center"
                            style={{ color: "orange" }}
                          >
                            No camera is connected. Please connect the camera(s)
                            to this device!
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                    {" "}
              </>
            </Box>
          </Box>

          {/* <Box sx={{ display: 'flex', flexGrow: 1 }}> */}
          {/* Main camera Content Layout */}

          {/* </Box> */}

          <div
            style={{
              marginTop: "2px",
              display: "flex",
              justifyContent: "center",
              marginBottom: "3cm",
              alignItems: "center",
            }}
          >
            <Snackbar
              open={this.state.open_snackbar}
              autoHideDuration={5000}
              onClose={() => this.setState({ open_snackbar: false })}
              anchorOrigin={{ vertical: "center", horizontal: "center" }}
            >
              <Alert
                onClose={() => this.setState({ open_snackbar: false })}
                variant="filled"
                elevation={6}
                severity={this.state.alert_type}
              >
                {this.state.snackbar_msg}
              </Alert>
            </Snackbar>
          </div>
          <div>
            {/* <button onClick={this.openDialog}>Delete Item</button> */}
            <DialogBox
              confirmDialog={confirmDialog}
              setConfirmDialog={(updatedDialog) =>
                this.setState({ confirmDialog: updatedDialog })
              }
              onConfirm={this.save_reference_image}
              onCancel={this.closeDialog}
            />
          </div>
        </div>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar}>
          <div className="custom-spinner">
            <div className="circle"></div>
            <div className="circle tilted"></div>
            <img
              src={WebLogo}
              alt="web-logo"
              style={{ backgroundColor: "#001f54", borderRadius: "100px" }}
            />
          </div>
          {/* <CircularProgress size={80} color="inherit" /> */}
               {" "}
        </Backdrop>
      </div>
    );
  }
}

export default withNavigate(AboutDevice);